var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isVisible ? _c('div', [_c('div', {
    staticClass: "property-indicator",
    class: {
      'property-indicator--alt-pos': _vm.useAlternateIndicatorPosition,
      'property-indicator--rtl': _vm.lang.rtl
    }
  }, _vm._l(_vm.markers, function (marker, i) {
    return _c('div', {
      key: "marker:".concat(i)
    }, [_c('AvailabilityMarker', {
      attrs: {
        "status": marker.status,
        "x": _vm.lang.rtl ? 155 : 0,
        "y": 5 + 56 * i
      }
    }), _c('div', {
      attrs: {
        "dir": _vm.lang.rtl ? 'rtl' : 'ltr'
      }
    }, [_vm._v(_vm._s(_vm.counts[marker.status] || 0) + " - " + _vm._s(marker.label))])], 1);
  }), 0)]) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }